import { Spin, Typography } from 'antd';
import Title from 'antd/lib/typography/Title';
import { FC } from 'react';
import { connect } from 'react-redux';
import download from '../../images/download.webp';

import { Dispatch } from 'redux';
import { SaveFeedbackAction, StoreAction } from '../../app/ActionsImpl';
import { translations } from '../../utils/LocalizedStrings';
import {
  StyledContainer
} from './DocumentDownload.styled';

interface Props extends DispatchProps {
  postError: any
}

const { Paragraph, Text } = Typography;

const DocumentDownloadPage: FC<Props> = ({
  postError
}) => {
  return (
    <StyledContainer>
      <div className="downloadLoader" />
      <img className="downloadPicture" src={download} alt="picture" />
      <div className="downloadPictureBackground"></div>
      {!postError ?
        <Title className="downloadTitle2">
          {translations.artifacts.DocumentsDownload?.weAreCookingYourDocuments}
          <br /> {translations.artifacts.DocumentsDownload?.itDoesntTakeMoreThan}
          <Spin className='spinLoading' />
        </Title>
        :
        <Title className="downloadTitle2">
          {translations.artifacts.DocumentsDownload?.sthWntWrong}
          <br /> {translations.artifacts.DocumentsDownload?.sthWntWrong2}
        </Title>
      }
    </StyledContainer>
  );

};

const mapStateToProps = ({ appState }: any) => ({
  company: appState.company
});


interface DispatchProps {
  saveFeedback: (marketingId: string, rating: number, feedbackMessage: string) => void;
}

function mapDispatchToProps(dispatch: Dispatch<StoreAction, any>): DispatchProps {
  return {
    saveFeedback: (marketingId: string, rating: number, feedbackMessage: string) => dispatch(SaveFeedbackAction(marketingId, rating, feedbackMessage))

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentDownloadPage);
